import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	workflowStatus: {
		id: 'language-settings.workflow-status',
		defaultMessage: 'Translate Jira issue status names in Jira admin settings',
		description: 'Workflow statuses page link label',
	},
	workflowStatusNonAdminHelp: {
		id: 'language-settings.workflow-status-non-admin-help',
		defaultMessage: 'Contact your Jira admin to translate Jira issue status names',
		description: 'Workflow statuses non admin help page link label',
	},
	header: {
		id: 'language-settings.header',
		defaultMessage: '{language} translations',
		description:
			'Header for page that lets users enter translations for strings in their Jira projects. {language} will be replaced with the name of the language being translated to.',
	},
});
